export default {
  computed: {
    hasRegionFilter() {
      return this.search_settings[this.route].region
    },
    isAnEventCalendar() {
      return this.isRAAgenda || this.isCalendarOfEvents || this.isAffiliateEvents
    },
    isOEA() {
      return window.drupalSettings.searchSettings?.SITE_CODE === 'oea'
    },
    isRAAgenda() {
      return this.route === 'ra_agenda'
    },
    isAffiliateEvents() {
      return this.route === 'standard_events'
    },
    isCalendarOfEvents() {
      return this.route === 'ra_calendar'
    },
  },
  methods: {
    eventTypeFriendly(item) {
      return Array.isArray(item.event_type_friendly)
        ? item.event_type_friendly[0]
        : item.event_type_friendly
    },
    isEyeOnEquityEvent(item) {
      const eyeOnEquityTid = window.drupalSettings.search.tids.EYE_ON_EQUITY_TID

      return this.isOEA && item.event_type === String(eyeOnEquityTid)
    },
  }
}
